import "./app.scss";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBfxOAux58Xw4FjcCWpxcGmygzJcpspy7Y",
  authDomain: "leafar-fd10b.firebaseapp.com",
  projectId: "leafar-fd10b",
  storageBucket: "leafar-fd10b.appspot.com",
  messagingSenderId: "639740376207",
  appId: "1:639740376207:web:2a8d52dedcea26be81ecfa",
  measurementId: "G-1DLLQB7MKW",
};

initializeApp(firebaseConfig);

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

window.dataLayer = window.dataLayer || [];
window.gtag = function () { window.dataLayer.push(arguments); };
window.gtag("js", new Date());
window.gtag("config", firebaseConfig.measurementId);
